import { render, staticRenderFns } from "./listproject.vue?vue&type=template&id=00925b53"
import script from "./listproject.vue?vue&type=script&lang=js"
export * from "./listproject.vue?vue&type=script&lang=js"
import style0 from "./listproject.vue?vue&type=style&index=0&id=00925b53&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports